module.exports = {
  env: 'development',
  aegisId: 'yrpj3fl9ZbjVJgrGR4',
  reportDomain: 'baike.sparta.html5.qq.com',
};
